import { Injectable } from '@angular/core';
import { Router, CanMatch, Route, UrlSegment, UrlTree, UrlSerializer } from '@angular/router';
import { BaseTokenService } from '../services/base-token.service';
import { BaseAppRoutes } from '../../shared/constants/base-app-routes';

@Injectable({ providedIn: 'root' })
export class BaseAuthGuard implements CanMatch {
  constructor(private tokenService: BaseTokenService, private router: Router, private urlSerializer: UrlSerializer) {}

  canMatch(_: Route, segments: UrlSegment[]): boolean | UrlTree {
    if (this.tokenService.isAuthenticated()) {
      return true;
    }

    return this.redirectTree(this.getRedirectUrl(segments));
  }

  private redirectTree(targetUrl: string): UrlTree {
    return this.router.createUrlTree([BaseAppRoutes.login], { queryParams: { redirectUrl: targetUrl } });
  }

  private getRedirectUrl(segments: UrlSegment[]): string {
    const nav = this.router.getCurrentNavigation();
    const urlTree = nav?.extractedUrl ?? this.router.parseUrl('/' + segments.map((s) => s.path).join('/'));

    return this.urlSerializer.serialize(urlTree);
  }
}
